//Carousel Script
if (document.querySelector(".image-slider .glide__slides")) {
	var allSlides = document.querySelectorAll(".glide");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	
	allSlidesArray.forEach((slide) => {
		
		const glide = new Glide(slide, {
			type: "slider",
			perView: 1,
			perTouch: 1,
			focusAt: "center",
			autoplay: false,
			accessibility: true,
			startAt: 0,
			rewind: true,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			}
		}).mount();
		// Initialize the slide counter
        let slider_counter = document.querySelector('.slide-counter');
        if (slider_counter) {
            slider_counter.textContent = '01/' + formattedTotalSlides;
        }

        // Preserve the margin-left on the first slide
        let firstSlide = slide.querySelector('.glide__slide:first-child');
        if (firstSlide) {
            firstSlide.style.marginLeft = '0px';
        }

        // Add an event listener for the 'run.after' event
        glide.on('run.after', function () {
            // Get the current slide index (zero-based)
            var currentIndex = glide.index;

            // Update the slide counter
            if (slider_counter) {
                let itemcounter = (currentIndex + 1);
                let resultitemcounter = String(itemcounter).padStart(2, '0');
                slider_counter.textContent = resultitemcounter + '/' + formattedTotalSlides;
            }
        });
    });
}
